import * as R from 'ramda'

/**
 *
 * @param {object} survey survey data
 * @param {boolean} survey.use_experiment_feature
 */
export function isV2Survey(survey) {
  return R.prop('use_experiment_feature', survey)
}

export const questionMap = {
  comment: {
    label: 'Comment box',
    iconClassName: 'violet fas fa-quote-left',
  },
  multipleChoice: {
    label: 'Multiple choice',
    iconClassName: 'green fas fa-list',
  },
  multi_select_choice: {
    label: 'Multi-select',
    iconClassName: 'blue fas fa-list-check',
  },
  slider: {
    label: 'Sliding scale',
    iconClassName: 'yellow fas fa-square-sliders',
  },
  file_upload: {
    label: 'File upload',
    iconClassName: 'violet far fa-paperclip',
  },
}

const iconTypeToSizeValueMap = {
  icon: {
    small: 30,
    medium: 40,
    large: 60,
  },
  emoji: {
    small: 22,
    medium: 30,
    large: 38,
  },
}
export function getIconSize(iconType, iconSizeLabel) {
  return R.path([iconType, iconSizeLabel], iconTypeToSizeValueMap)
}

/**
 *
 * @param {'1' | '2' | '3' | '4' | '5'} value
 */
export function mapRatingValueToEmoji(value) {
  return {
    1: '😡',
    2: '😠',
    3: '😐',
    4: '😀',
    5: '😍',
  }[value]
}

/**
 *
 * @param {'1' | '2' | '3' | '4' | '5'} value
 */
export function mapRatingValueToBackgroundColor(value) {
  return {
    1: '#920111',
    2: '#D00218',
    3: '#FBBD08',
    4: '#4EC677',
    5: '#2A8449',
  }[value]
}

/**
 *
 * @param {'small' | 'medium' | 'large'} iconSizeLabel
 */
export function getLabelFontSize(iconSizeLabel) {
  return {
    small: 12,
    medium: 14,
    large: 16,
  }[iconSizeLabel]
}

/**
 *
 * @param {'small' | 'medium' | 'large'} iconSizeLabel
 * @param {boolean} shouldShowLabel
 */
export function getEmailPreviewIframeHeight(iconSizeLabel, shouldShowLabel) {
  const questionTextSpace = 30
  if (!shouldShowLabel) {
    return (
      {
        small: 90,
        medium: 100,
        large: 120,
      }[iconSizeLabel] + questionTextSpace
    )
  }
  return (
    {
      small: 110,
      medium: 120,
      large: 140,
    }[iconSizeLabel] + questionTextSpace
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/survey/index.js